import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { WellHeaderInfoService } from 'app/modules/well-header-information/services/well-header-info.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { noWhitespaceValidator } from 'app/core/shared/helper/form.helper';
import module from "app/modules/well-header-information/well-header-information.module";

@Component({
  selector: 'app-edit-wellbore-modal',
  templateUrl: './edit-wellbore-modal.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: module,
  styleUrls: ['./edit-wellbore-modal.component.scss']
})
export class EditWellboreModalComponent {
  public wellboreForm: FormGroup
  public isSuccess: boolean = false
  public isLoading: boolean = false

  constructor(
    public dialogRef: MatDialogRef<EditWellboreModalComponent>,
    @Inject(MAT_DIALOG_DATA) public wellboreData: any,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private wellHeaderInfoService: WellHeaderInfoService
  ) { }

  ngOnInit() {
    this.wellboreForm = this.initializeForm()

    this.wellboreForm.get('wellboreShortName')?.valueChanges.subscribe(value => {
      if (value && value !== value.toUpperCase()) {
        this.wellboreForm.get('wellboreShortName')?.setValue(value.toUpperCase(), { emitEvent: false });
      }
    });

    this.wellboreForm.setValue({
      id:  this.wellboreData.wellboreId,
      wellId: this.wellboreData.wellId,
      wellboreShortName: this.wellboreData.name,
      wellboreLongName: this.wellboreData.longName,
      wellboreStatus: this.wellboreData.status,
      wellboreNumber: '',
      rigName:  this.wellboreData.rigName,
      uwbi: '',
      spudDate: this.wellboreData.spudDate,
      thfRkbElevation: 0,
      completionDate: this.wellboreData.completionDate,
      waterDepth: 0,
      tvddf: 0,
      tvdss: 0,
      trajectoryShape: '',
      remarks: '',
    })
  }

  initializeForm(){
    return this.fb.group({
      id: this.wellboreData.wellboreId,
      wellId: this.wellboreData.wellId,
      wellboreShortName: ['', [Validators.required, noWhitespaceValidator()]],
      wellboreLongName: ['', [Validators.required, noWhitespaceValidator()]],
      wellboreStatus: '',
      wellboreNumber: '',
      rigName: '',
      uwbi: '',
      spudDate: new Date,
      thfRkbElevation: 0,
      completionDate: new Date,
      waterDepth: 0,
      tvddf: 0,
      tvdss: 0,
      trajectoryShape: '',
      remarks: '',
    })
  }

  updateWellbore() {
    this.isLoading = true

    this.wellHeaderInfoService.updateWellbore(this.wellboreForm.value).subscribe(
      {
        next: (res) => {
          if (res.isSuccess) {
            this.isSuccess = true
            this.closeDialog()
          }
          this.isLoading = false
        },
        error: (err) => this.isLoading = false
      })
  }

  closeDialog(): void {
    this.dialogRef.close(this.isSuccess);
  }

  
  get wellboreLongName() {
    return this.wellboreForm.get('wellboreLongName');
  }

  get wellboreShortName() {
    return this.wellboreForm.get('wellboreShortName');
  }
}
